import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';

const fiscalYearSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
  isCurrent: z.boolean(),
});

const fiscalYearListSchema = z.array(fiscalYearSchema);

export type FiscalYear = z.infer<typeof fiscalYearSchema>;

export const fiscalYearListQueryOptions = () =>
  queryOptions({
    queryKey: ['fiscal-years'] as const,
    queryFn: async (): Promise<FiscalYear[]> => {
      const res = await apiClient.get(API.settingsLookups.fiscalYears);
      return fiscalYearListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });
